import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { CancelIcon } from '@depop/web-ui-kit/Icons/CancelIcon';
import { Panel } from '@depop/web-ui-kit/Panel';
import { VisuallyHidden } from '@depop/web-ui-kit/VisuallyHidden';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

type Props = {
  IconComponent: (props: Record<string, unknown>) => React.ReactElement;
  title: string;
  children: React.ReactNode;
  onClose?: () => void;
  noMargin?: boolean;
  className?: string;
};

export function InfoPanel({
  IconComponent,
  title,
  children,
  onClose,
  noMargin,
  className,
}: Props) {
  const t = useTranslations('common');

  return (
    <Panel
      id={title}
      className={clsx(styles.panelWrapper, className, {
        [styles.panelMargin]: !noMargin,
      })}
      aria-label={title}
      type="info"
      role="note"
    >
      <IconComponent size={36} className={styles.panelIcon} />
      <div>
        <Body variant="sm-bold">{title}</Body>
        {children}
      </div>
      {onClose && (
        <button className={styles.panelCloseButton} onClick={onClose}>
          <CancelIcon size={16} />
          <VisuallyHidden>{t('Close')}</VisuallyHidden>
        </button>
      )}
    </Panel>
  );
}
